module.exports = __webpack_public_path__ + "img/problem_icon.a0234d7a.png";